const binding = { modules: {}, dataActions: {} };

    (binding.modules['invisible-anchor'] = {
        c: () => require('partner/modules/invisible-anchor/invisible-anchor.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'invisible-anchor',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/invisible-anchor'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };